import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
  toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  filterModel: null,
  quickFilterText: "",
};

const workOrdersSlice = createSlice({
  name: "workOrders",
  initialState,
  reducers: {
    setDates: (state, action) => {
      state.fromDate = action.payload.fromDate;
      state.toDate = action.payload.toDate;
    },
    setFilterModel: (state, action) => {
      state.filterModel = action.payload;
    },
    setQuickFilterText: (state, action) => {
      state.quickFilterText = action.payload;
    },
    resetWorkOrdersState: () => initialState,
  },
});

export const {
  setDates,
  setFilterModel,
  setQuickFilterText,
  resetWorkOrdersState,
} = workOrdersSlice.actions;

export default workOrdersSlice.reducer;